/* eslint-disable func-names, max-len */
import 'fancybox-core';
import 'fancybox-media';

const self = {};

/* Returns the value of cookie based on the given name.
       Returns an empty string if the cookie cannot be found. */
self.getCookie = function (cname) {
  const name = `${cname}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

/* Set the value of a cookie based on the given name, value and length in days.
       If no length is given the cookie will expire at the end of the session. */
self.setCookie = function (cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  const expires = `expires=${d.toUTCString()}`;
  if (exdays) {
    document.cookie = `${cname}=${cvalue}; ${expires}`;
  } else {
    document.cookie = `${cname}=${cvalue}`;
  }
};

/* Set the width of the div to the same size of the image.
       The image is positioned absolute to that is can stick out the top of the fancybox,
       as a result the div doesn't have a width. */
self.calculateImageWidth = function () {
  const $imageCell = $('.header__cell--logo');
  if ($imageCell.length > 0) {
    const $image = $imageCell.find('img');
    if ($image.length > 0) {
      $imageCell.width($image[0].naturalWidth);
    }
  }
};

self.animateTerms = function () {
  // Terms animation
  $('.view-terms-conditions-agree.primary').click(() => {
    const $termsText = $('.win-terms-text.primary');

    if (!$termsText.hasClass('open-terms')) {
      $termsText.addClass('open-terms');
      $termsText.addClass('subscription-lightbox-terms');
      $termsText.height($termsText.attr('data-height'));
    } else {
      $termsText.removeClass('open-terms');
    }
  });
  // Open Terms animation
  $('.view-terms-conditions-agree.secondary').click(() => {
    const $termsText = $('.win-terms-text.secondary');

    if (!$termsText.hasClass('open-terms')) {
      $termsText.addClass('open-terms');
      $termsText.addClass('subscription-lightbox-terms');
      $termsText.height($termsText.attr('data-height'));
    } else {
      $termsText.removeClass('open-terms');
      $termsText.removeClass('subscription-lightbox-terms');
    }
  });

  // Close on X
  $('.win-terms-text .close-terms').click(() => {
    const $termsText = $('.win-terms-text');

    if (!$termsText.hasClass('open-terms')) {
      $termsText.addClass('open-terms');
    } else {
      $termsText.removeClass('open-terms');
      $termsText.removeClass('subscription-lightbox-terms');
    }
  });

  // Close terms on esc
  $(document).keyup((e) => {
    if (e.keyCode === 27) {
      const $termsText = $('.win-terms-text');

      if ($termsText.hasClass('open-terms')) {
        $termsText.removeClass('open-terms');
        $termsText.removeClass('subscription-lightbox-terms');
      }
    }
  });
};

self.termsHeight = function () {
  const $termsPopup = $('.win-terms-text');
  if ($termsPopup.length > 0) {
    $termsPopup.prependTo('form');

    const $termsHeading = $termsPopup.find('h1, h2');
    const $termsText = $termsPopup.find('p');
    if ($termsHeading.length > 0 && $termsText.length > 0) {
      // $termsText.css('height', 'calc(100% - ' + $termsHeading.outerHeight() + 'px)');
    }
  }
};

self.positionFix = function () {
  // Sometimes the popup doesn't initialise properly, we need to move the div so the image is displayed correctly.
  $('.fancybox-subscription-lightbox .fancybox-type-inline').each(function () {
    $(this).parent().before(this);
  });
};

self.initialise = function () {
  const $subLightboxes = $('.subscription-lightbox');

  $subLightboxes.each(() => {
    self.animateTerms();
    self.termsHeight();
    $(window).resize(self.termsHeight);

    const width = Math.min(420, window.innerWidth);
    let loadFancybox = true;

    if (self.getCookie('SubscriptionLightboxClosed') === 'true') {
      return;
    }

    // Call a WebAPI method to check if the current contact has already subscribed.
    $.ajax({
      method: 'GET',
      url: '/api/subscription/CurrentContactSubscribedToLightbox',
      async: true,
      complete(data) {
        loadFancybox = (data.responseJSON === false);

        // Don't show the fancybox if the contact has already subscribed or already closed it this session.
        if (loadFancybox !== true) {
          return;
        }

        $.fancybox({
          // settings
          autoHeight: true,
          autoSize: false,
          closeBtn: true,
          href: '#sub-lightbox-container',
          padding: 0,
          parent: 'form:first',
          width,

          // events
          beforeShow() {
            $('.btn', this.inner).click(() => {
              $.fancybox.reposition(); // centre after error messages display.
            });

            $('input', this.inner).blur(() => {
              $.fancybox.reposition(); // centre after error messages are hidden.
            });
            self.positionFix();
          },
          afterShow() {
            self.calculateImageWidth();

            if (this.href === '#sub-lightbox-container') {
              $('.fancybox-overlay').addClass('fancybox-subscription-lightbox');
            }
            self.positionFix();
          },
          afterClose() {
            // Set a cookie so the popup is not shown again this session.
            self.setCookie('SubscriptionLightboxClosed', 'true');
          },
        });
      },
    });

    self.positionFix();

    Sys.WebForms.PageRequestManager.getInstance().add_endRequest(self.calculateImageWidth);
  });
};

self.initialise();
